module.exports = __webpack_public_path__ + "static/media/pg_sample_left_beaker.d4764c79.svg";